// extracted by mini-css-extract-plugin
export default {"Galleries":"Galleries_Galleries__r-r4y","GalleriesImage":"Galleries_GalleriesImage__ovaih","GalleriesImageWrapper":"Galleries_GalleriesImageWrapper__ECK2m"};